import React from 'react'
import {SignatureComponent} from "module/CustomField/component/input/SignatureComponent";
import {CFComponentLazyProps} from 'module/CustomField/type/CFComponentType';
import {cssCustomFieldComponentBorder} from 'module/CustomField/style/CustomFieldBorderCSS'

const style = {textAlign: 'center'} as const

export function CustomFieldSignatureComponent(props: CFComponentLazyProps) {
	return (
		<div
			className={'CustomFieldSignatureComponent CustomFieldComponentBorder'}
			css={cssCustomFieldComponentBorder}
			data-cursor-key-needs-modifier={true}
			style={style}
		>
			<SignatureComponent {...props}/>
		</div>
	)
}